import { render } from "./ColorRichText.vue?vue&type=template&id=65e4a25a"
import script from "./ColorRichText.vue?vue&type=script&lang=js"
export * from "./ColorRichText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__